import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { PageShellComponent } from '@shared/components/page-shell/page-shell.component';
import { RegbrTabsComponent } from './components/regbr-tabs.component';
import { RegbrMetricNavComponent } from './components/regbr-metric-nav.component';

@Component({
  selector: 'app-regbr-metricas-page',
  standalone: true,
  imports: [
    TranslocoPipe,
    PageShellComponent,
    RegbrTabsComponent,
    RegbrMetricNavComponent,
    RouterOutlet,
  ],
  templateUrl: './regbr-metricas.page.html',
})
export class RegbrMetricasPage {
  protected readonly breadcrumb = [
    { labelKey: 'nav.items.regbr', path: '/regbr' },
    { labelKey: 'pages.regbr.tabs.metrics' },
  ];
}
